import Heading from '@/components/_atoms/Heading';
import { Container } from '@/components/layout/Container';
import { mediaBreakpointUp, paddingY } from '@/styles/layout/utils';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface GradientFooterProps {
  heading: string;
  cta?: ReactNode;
}

const GradientFooter: FC<GradientFooterProps & PropsWithClassName> = (props) => {
  return (
    <Footer className={props.className}>
      <Container>
        <Grid>
          <StyledHeading level={2}>{props.heading}</StyledHeading>
          {props.cta ? <ButtonWrapper>{props.cta}</ButtonWrapper> : null}
        </Grid>
      </Container>
    </Footer>
  );
};

export default GradientFooter;

// Styled Components

const Footer = styled.section`
  position: relative;
  ${paddingY(80)}

  ${mediaBreakpointUp('tablet')} {
    ${paddingY(120)}
  }

  ${mediaBreakpointUp('desktop')} {
    ${paddingY(160)}
  }

  ${mediaBreakpointUp('desktopWide')} {
    ${paddingY(220)}
  }

`;

const StyledHeading = styled(Heading)`
  text-align: center;
  margin-bottom: ${remCalc(20)};
  grid-column: 1 / -1;

  ${mediaBreakpointUp('tablet')} {
    ${customTextSize(49, 58)};
    margin-bottom: ${remCalc(30)};
  }

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(60, 66)};
  }

  ${mediaBreakpointUp('desktopWide')} {
    ${customTextSize(81, 88)};
    grid-column: 2 / -2;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-column-gap: ${remCalc(20)};

  ${mediaBreakpointUp('tablet')} {
    grid-template-columns: repeat(9, 1fr);
  }
`;

const ButtonWrapper = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;

  ${mediaBreakpointUp('tablet')} {
    flex-direction: row;
  }
`;
